import { Enums } from '@libs/mtjr/shared/generated/types';
import { Expose } from 'class-transformer';

export class VendorUpdateDtoMap {
  @Expose()
  deleted?: boolean;

  @Expose()
  name?: string;

  @Expose()
  addressLabel?: string;

  @Expose()
  addressStreet?: string;

  @Expose()
  addressInternal?: string;

  @Expose()
  addressPhone?: string;

  @Expose()
  addressPhone2?: string;

  @Expose()
  addressLat?: number;

  @Expose()
  addressLng?: number;

  @Expose()
  logo?: string;

  @Expose()
  background?: string;

  @Expose()
  allowedPaymentMethods?: Enums.PaymentMethod[];
}
